"use client";
import * as React from "react";
const SvgAutomaticGearSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 15 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.03 0H3.68v8.8H.5v2.8h3.18V16h7.35v-4.4h3.18V8.8h-3.18zM5.26 14.4v-2.8h4.18v2.8zM9.44 1.6v7.2h-1.3v-4H6.57v4h-1.3V1.6zm5.13.53H15V0h-2.38v3.2h.71V2.13h.53l.43 1.07H15zM14.28.8v.53h-.95V.8zM15 6.53h-1.67V7.6h-.71V4.4H15zm-.71-.8V5.2h-.96v.53zM15 13.6c0-.43-.33-.8-.71-.8h-1.67V16h1.67c.38 0 .71-.37.71-.8zm-.71 0v1.6h-.96v-1.6z", clipRule: "evenodd" }));
export {
  SvgAutomaticGearSharp as default
};
